import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'
import { Spinner } from '@wartek-id/spinner'

import { assetUrl } from 'utils/url'
import { parseQuery } from 'utils/router'
import { useAuth } from 'utils/auth'

const largeBannerPath = assetUrl(
  '/images/pengelolaan-kinerja/landing/landing-banner-lg.png'
)
const smallBannerPath = assetUrl(
  '/images/pengelolaan-kinerja/landing/landing-banner-sm.png'
)

export function KinerjaLandingPage() {
  const router = useRouter()
  const { session } = useAuth()

  const isLoggedIn = !!session

  const fromQueryParam =
    parseQuery(router.query?.from, 'string') || '/pengelolaan-kinerja'

  // Redirect to the Pengelolaan Kinerja Beranda if logged-in
  useEffect(() => {
    if (isLoggedIn) {
      router.replace('/pengelolaan-kinerja')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <main className="min-h-screen flex flex-col justify-between">
      {isLoggedIn ? (
        <div className="flex space-x-3 w-full h-screen justify-center items-center">
          <Spinner /> <Text>Memuat...</Text>
        </div>
      ) : (
        <>
          <section className="max-w-6xl mx-auto pt-44 pb-28 sm:pb-40 sm:pt-40 px-0 gap-8 sm:gap-12 lg:gap-8 sm:px-14 flex justify-center items-center flex-col-reverse lg:flex-row">
            <div className="w-96 max-w-full flex-shrink-0 flex-grow-0 px-6 xl:px-0">
              <div className="shadow-2xl px-8 pb-8 pt-16 text-center rounded-lg">
                <h1 className="mb-6">
                  <span className="sr-only">Pengelolaan Kinerja</span>
                  <img
                    src={assetUrl('/icon/e-pengelolaan-kinerja-logo.png')}
                    alt=""
                    width="254"
                    height="64"
                    className="w-60 max-w-full mx-auto"
                  />
                </h1>
                <Text className="mb-10" variant="heading-sm">
                  Mudah, bermakna, dan bermutu <br />
                  untuk semua.
                </Text>
                <Link
                  href={{
                    pathname: '/login',
                    query: {
                      from: fromQueryParam,
                      referer: 'pengelolaan-kinerja',
                    },
                  }}
                  passHref
                >
                  <Button as="a" type={undefined} className="w-full" size="lg">
                    Masuk
                  </Button>
                </Link>
              </div>
            </div>
            <div className="w-full overflow-hidden">
              <img
                className="scale-105 sm:scale-100"
                src={smallBannerPath}
                srcSet={`${smallBannerPath} 786w, 
                 ${largeBannerPath} 1380w`}
                sizes="(max-width: 768px) 786px, 
                1380px"
                alt=""
                width="786"
                height="314"
              ></img>
            </div>
          </section>

          <section className="flex-grow bg-[#ABE4F7] px-5 sm:px-6 py-12 sm:py-16 rounded-t-64">
            <div className="max-w-4xl mx-auto">
              <Text
                as="h2"
                variant="heading-lg"
                className="max-w-xl text-center mx-auto mb-8 sm:mb-12 xl:mb-10 px-5 sm:px-0"
              >
                Tiga kemudahan utama agar Bapak dan Ibu bisa berfokus pada
                peningkatan pembelajaran murid di tahun 2025
              </Text>

              <div className="flex flex-col sm:flex-row gap-10 sm:gap-4 lg:gap-10 items-center sm:items-stretch mb-8 lg:mb-10">
                <article className="p-6 sm:p-4 lg:p-6 rounded-16 bg-cyan-5 flex-grow flex-shrink w-64 sm:w-full">
                  <img
                    alt=""
                    src={assetUrl('/illustrations/img-calendar-1x.png')}
                    width="84"
                    height="84"
                    className="mx-auto mb-6"
                  />
                  <Text variant="heading-sm" className="text-center" as="h3">
                    Dilaksanakan satu kali setahun
                  </Text>
                </article>
                <article className="p-6 sm:p-4 lg:p-6 rounded-16 bg-cyan-5 flex-grow flex-shrink w-64 sm:w-full">
                  <img
                    alt=""
                    src={assetUrl('/illustrations/img-folder-document-2.png')}
                    width="84"
                    height="84"
                    className="mx-auto mb-6"
                  />
                  <Text variant="heading-sm" className="text-center" as="h3">
                    Tidak perlu mengunggah dokumen akuntabilitas
                  </Text>
                </article>
                <article className="p-6 sm:p-4 lg:p-6 rounded-16 bg-cyan-5 flex-grow flex-shrink w-64 sm:w-full">
                  <img
                    alt=""
                    src={assetUrl(
                      '/illustrations/img-term-condition-TnC-list.png'
                    )}
                    width="84"
                    height="84"
                    className="mx-auto mb-6"
                  />
                  <Text variant="heading-sm" className="text-center" as="h3">
                    Tidak berbasis poin
                  </Text>
                </article>
              </div>

              <Button
                as="a"
                className="mx-auto hover:!bg-transparent"
                href="https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id/articles/40842562214297-Tentang-penyederhanaan-Pengelolaan-Kinerja"
                size="lg"
                target="_blank"
                type={undefined}
                variant="ghost"
              >
                Baca artikel lengkap Pengelolaan Kinerja
              </Button>
            </div>
          </section>
        </>
      )}
    </main>
  )
}
